import { Link } from 'react-router-dom';
import Logo from '@/components/core/Logo';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="privacy-policy-page">
      {/* Navbar */}
      <nav className="sticky top-0 z-50 border-b border-border bg-background/80 backdrop-blur-sm">
        <div className="max-w-4xl mx-auto px-6 h-14 flex items-center">
          <Logo />
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="font-heading text-4xl font-[500] tracking-tight mb-8">Privacy Policy</h1>
        <p className="font-mono text-xs uppercase tracking-[0.15em] text-muted-foreground mb-8">
          Last updated: February 2026
        </p>

        <div className="prose prose-neutral max-w-none space-y-8">
          <section>
            <h2 className="font-heading text-xl font-[500] mb-4">1. Information We Collect</h2>
            <p className="font-body text-muted-foreground leading-relaxed mb-4">
              When you use Atlas, we collect information you provide directly to us, including:
            </p>
            <ul className="list-disc pl-6 space-y-2 font-body text-muted-foreground">
              <li>Account information (name, email address, password)</li>
              <li>Mind maps and content you create</li>
              <li>Usage data and interactions with our AI features</li>
              <li>Payment information (processed securely through our payment provider)</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-[500] mb-4">2. How We Use Your Information</h2>
            <p className="font-body text-muted-foreground leading-relaxed mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 space-y-2 font-body text-muted-foreground">
              <li>Provide, maintain, and improve our services</li>
              <li>Process transactions and send related information</li>
              <li>Send you technical notices, updates, and support messages</li>
              <li>Respond to your comments, questions, and customer service requests</li>
              <li>Personalize and improve your experience</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-[500] mb-4">3. Data Storage and Security</h2>
            <p className="font-body text-muted-foreground leading-relaxed">
              We implement appropriate technical and organizational measures to protect your personal data against unauthorized or unlawful processing, accidental loss, destruction, or damage. Your data is stored on secure servers with encryption at rest and in transit.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-[500] mb-4">4. Data Sharing</h2>
            <p className="font-body text-muted-foreground leading-relaxed">
              We do not sell, trade, or otherwise transfer your personal information to third parties. We may share your information only in the following circumstances:
            </p>
            <ul className="list-disc pl-6 space-y-2 font-body text-muted-foreground mt-4">
              <li>With service providers who assist in our operations</li>
              <li>To comply with legal obligations</li>
              <li>To protect our rights, privacy, safety, or property</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-[500] mb-4">5. Your Rights</h2>
            <p className="font-body text-muted-foreground leading-relaxed mb-4">
              You have the right to:
            </p>
            <ul className="list-disc pl-6 space-y-2 font-body text-muted-foreground">
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Export your data in a portable format</li>
              <li>Withdraw consent at any time</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-[500] mb-4">6. Cookies</h2>
            <p className="font-body text-muted-foreground leading-relaxed">
              We use essential cookies to maintain your session and preferences. We do not use tracking cookies for advertising purposes.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-[500] mb-4">7. Contact Us</h2>
            <p className="font-body text-muted-foreground leading-relaxed">
              If you have any questions about this Privacy Policy, please contact us at privacy@atlas.app
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-border">
          <Link to="/" className="font-body text-sm text-cobalt hover:underline">
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
